<template>
  <div class="">
    <div v-show="logging" class="editpreview loading-mask">
      <i class="fas fa-circle-notch fa-spin" />
    </div>
    <div class="part part-1">
      <div :class="{'err-wrap': fetchedData.valid.member}" class="profile-popup slider-1 edit-preview">
        <h5 class="editing-heading">
        {{ cpLang('jd.your_profile') }}
        </h5>
        <h6 class="ld-cp-title">
         {{ cpLang('profile.personal_detail') }}
        </h6>
        <div class="row overflow-visible profile-pic-wrap l-flex l-j-center">
          <ProfilePic />
        </div>
        <div class="profile-pic-wrap">
          <EdtCurEmpStat
            :pass-location="filterPassLocation"
            :pass-visibility="passVisibility"
            :pass-employmenttype="passEmploymenttype"
            :init-data="expectation"
            :check-field="fetchAllData"
            @pass="validation($event, 'member')"
            is-apply-page
          />
        </div>
      </div>
    </div>
    <div class="part part-2">
      <div :class="{'err-wrap': fetchedData.valid.experiences}" class="profile-popup slider-2 edit-preview">
        <h6 class="ld-cp-title">
         {{ cpLang('profile.experience') }}
        </h6>
        <EdtWorkExp
          :jobfunction="passJobfunction"
          :industry="passIndustry"
          :location="passLocation"
          :joblevel="passJoblevel"
          :init-data="experiences"
          :check-field-all="fetchAllData"
          @pass="validation($event, 'experiences')"
          is-apply-page
        />
      </div>
    </div>
    <div class="part part-3">
      <div :class="{'err-wrap': fetchedData.valid.education}" class="profile-popup slider-2 edit-preview">
        <h6 :class="{'edu-err': eduerr}" class="ld-cp-title">
         {{ cpLang('profile.education_history') }}*
         <small v-show="eduerr" class="edu-err">At least one education background</small>
        </h6>
        <EdtEdu
          :edulvlist="passEduLvList"
          :major="passMajor"
          :init-data="educations"
          :check-field-all="fetchAllData"
          @pass="validation($event, 'education')"
          is-apply-page
        />
      </div>
    </div>
    <div class="part part-3">
      <div :class="{'err-wrap': fetchedData.valid.licenses}" class="profile-popup slider-2 edit-preview">
        <h6 :class="{'edu-err': eduerr}" class="ld-cp-title">
         {{ cpLang('profile.license_title') }}
        </h6>
        <EdtLicense
          :init-data="licenses"
          :check-field-all="fetchAllData"
          @pass="validation($event, 'education')"
          is-apply-page
        />
      </div>
    </div>
    <div class="part part-4">
      <div :class="{'err-wrap': fetchedData.valid.skills}" class="profile-popup slider-2 edit-preview">
        <h6 class="ld-cp-title">
         {{ cpLang('profile.expertise') }}
        </h6>
        <EdtExpertnSkill
          :pass-languages="passLanguages"
          :pass-proficiencies="passProficiencies"
          :pass-skills="passSkills"
          :check-field="fetchAllData"
          @pass="validation($event, 'skills')"
          is-apply-page
        />
      </div>
    </div>
    <div class="part part-5">
      <div :class="{'err-wrap': fetchedData.valid.contact}" class="profile-popup slider-2 edit-preview">
        <h6 class="ld-cp-title">
         {{ cpLang('profile.contact_info') }}
        </h6>
        <EdtContact
          :init-data="contact"
          :check-field="fetchAllData"
          @pass="validation($event, 'contact')"
          is-apply-page
        />
      </div>
    </div>
    <div class="text-center mt-3">
      <button @click="fetchData()" class="btn btn-primary">
        {{ cpLang('jd.preview_profile') }}
      </button>
    </div>
  </div>
</template>

<script>
import ProfilePic from '@/components/profile/ProfilePic'
import EdtCurEmpStat from '@/components/profile/edit_profile/EdtCurEmpStat'
import EdtWorkExp from '@/components/profile/edit_profile/EdtWorkExp'
import EdtEdu from '@/components/profile/edit_profile/EdtEdu'
import EdtExpertnSkill from '@/components/profile/edit_profile/EdtExpertnSkill'
import EdtLicense from '@/components/profile/edit_profile/EdtLicense'
import EdtContact from '@/components/profile/edit_profile/EdtContact'
import commonFunc from '~/assets/js/commonHelper.js'

export default {
  components: {
    ProfilePic,
    EdtCurEmpStat,
    EdtWorkExp,
    EdtEdu,
    EdtExpertnSkill,
    EdtLicense,
    EdtContact
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      logging: false,
      member: [],
      languages: [],
      skills: [],
      experiences: null,
      educations: null,
      licenses: null,
      contact: null,
      contact_num: '',
      expectation: null,
      selectedTemplate: 'A',
      showExport: false,
      // for passobj to component
      passLocation: [],
      filterPassLocation: [],
      passJoblevel: [],
      passEmploymenttype: [],
      passJobfunction: [],
      passIndustry: [],
      passEduLvList: [],
      passMajor: [],
      passLanguages: [],
      passProficiencies: [],
      passSkills: [],
      passVisibility: [
        { id: 1, desc: this.cpLang('profile.vis_searchable') },
        { id: 2, desc: this.cpLang('profile.vis_private') },
        { id: 3, desc: this.cpLang('profile.vis_anonymous') }
      ],
      //
      expObj: null,
      eduObj: null,
      skillObj: null,
      memberObj: null,
      summaryObj: {},
      fetchAllData: false,
      fetchedData: {
        member: null,
        expectation: null,
        experiences: null,
        education: null,
        languages: null,
        licneses: null,
        skills: null,
        contact: null,
        valid: {
          member: false,
          experiences: false,
          education: false,
          skills: false,
          contact: false
        }
      },
      eduerr: false,
      count: 0
    }
  },
  watch: {
    count(v) {
      const vm = this
      this.scrollToError()
      if (v === 6) {
        this.submit().then(function () {
          vm.count = 0
        })
      }
      if (v > 6) {
        vm.count = 0
      }
    }
  },
  async beforeMount() {
    const vm = this
    this.logging = true
    await this.getAllInitialData().then(function() {
      // all member data
      vm.getExpectation()
      // vm.getExpertise()
      vm.getExperiences()
      vm.getLicenses()
      vm.getEducations()
      vm.getContact()
      vm.getMember()
    }).then(function () {
      vm.logging = false
    })
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    scrollToError: function() {
      // const toErr = document.querySelector('.err-wrap')
      // let errTop = 0
      // if (toErr) {
      //   errTop = toErr.offsetTop
      //   window.scrollTo(0, errTop)
      // }
    },
    fetchData: function() {
      this.fetchAllData = !this.fetchAllData
    },
    validation: function(e, name) {
      if (name === 'member') {
        this.fetchedData.valid.member = e.valid
        this.count++
      }
      if (name === 'experiences') {
        if (e === 'pass') {
          this.fetchedData.valid.experiences = true
        } else {
          this.fetchedData.valid.experiences = false
          if (!e.valid) {
            console.log('have false')
            this.fetchedData.valid.experiences = false
          } else {
            this.fetchedData.valid.experiences = true
          }
        }
        this.count++
      }
      if (name === 'education') {
        if (e === 'mandate') {
          this.fetchedData.valid.education = false
          this.eduerr = true
        } else {
          this.eduerr = false
          const eduValid = e.valid
          if (!eduValid) {
            console.log('have false')
            this.fetchedData.valid.education = false
          } else {
            this.fetchedData.valid.education = true
          }
        }
        this.count++
      }
      if (name === 'skills') {
        this.fetchedData.valid.skills = e.valid
        this.count++
      }
      if (name === 'licenses') {
        // this.fetchedData.valid.contact = e.valid
        this.count++
      }
      if (name === 'contact') {
        this.fetchedData.valid.contact = e.valid
        this.count++
      }
    },
    submit: async function() {
      const res = await Object.keys(this.fetchedData.valid).every(k => this.fetchedData.valid[k])
      if (res) {
        try {
          const event = new Event('saveAll')
          window.dispatchEvent(event)
          this.logging = true
        } catch (err) {
          console.log(err)
        } finally {
          // this.$emit('change')
          location.reload()
        }
      } else {
        return false
      }
    },
    getAllInitialData: async function() {
      const vm = this
      await this.$axios.get('locations').then(function (response) {
        const data = response.data
        const filtedData = data.locations.filter(i => i.id !== 15)
        vm.filterPassLocation = filtedData.reverse()
        vm.passLocation = data.locations.reverse()
      })
      await this.$axios.get('studyfields').then(function (response) {
        const data = response.data
        vm.passMajor = data.studyfields
      })
      await this.$axios
        .get('positions?extrafield=property')
        .then(function (response) {
          const data = response.data
          vm.passJoblevel = data.joblevel
          vm.passEmploymenttype = data.employmenttype
          vm.passIndustry = data.industry
          vm.passEduLvList = data.education
          vm.passJobfunction = data.jobfunction
        })
      await this.$axios.get('skillexperiences').then(function (response) {
        const data = response.data
        data.skillexperiences.forEach(function (item) {
          vm.passSkills.push({ id: item.id, desc: item.skillexperiencedesc })
        })
      })
      await this.$axios.get('languages').then(function (response) {
        const data = response.data
        data.languages.forEach(function (item, index) {
          vm.passLanguages.push({ id: item.id, desc: item.languagedesc })
        })
        vm.passProficiencies = data.proficiencies
      })
    },
    checkEmpty: function (str) {
      return commonFunc.checkStrEmpty(str)
    },
    validObj: function (obj, k) {
      return commonFunc.validObj(obj, k)
    },
    formatTel: function (e) {
      if (e) {
        if (e.indexOf('-0') > -1) {
          return e.replace('-0', '')
        }
        return e
      }
    },
    displayAchievement: function (exp) {
      if (!exp || exp.achievement === undefined || exp.achievement === null) {
        return ''
      }
      return exp.achievement.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    displayRoles: function (exp) {
      if (!exp || exp.roles === undefined || exp.roles === null) {
        return ''
      }
      return exp.roles.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    addHttp: function (e) {
      if (e) {
        if (e.indexOf('https://') < 0) {
          return `http://${e}`
        }
        return e
      }
      return ''
    },
    formatDate: function (date) {
      const date2 = new Date(date.replace(/\s/g, 'T'))
      // const m = date2.getUTCMonth() + 1
      const monthNames = [
        this.cpLang('recruitmentday.jan_short'),
        this.cpLang('recruitmentday.feb_short'),
        this.cpLang('recruitmentday.mar_short'),
        this.cpLang('recruitmentday.apr_short'),
        this.cpLang('recruitmentday.may_short'),
        this.cpLang('recruitmentday.jun_short'),
        this.cpLang('recruitmentday.jul_short'),
        this.cpLang('recruitmentday.aug_short'),
        this.cpLang('recruitmentday.sep_short'),
        this.cpLang('recruitmentday.oct_short'),
        this.cpLang('recruitmentday.nov_short'),
        this.cpLang('recruitmentday.dec_short')
      ]
      return monthNames[date2.getUTCMonth()] + ' ' + date2.getFullYear()
      // if (
      //   !this.$cpCookie.get('revampLang') ||
      //   this.$cpCookie.get('revampLang') === 'en'
      // ) {
      // } else {
      //   return date2.getFullYear() + '年' + m + '月'
      // }
    },
    // getExpertise: async function () {
    //   const vm = this
    //   await this.$axios
    //     .get('member/profile/expertise')
    //     .then(function (response) {
    //       const data = JSON.parse(JSON.stringify(response.data))
    //       vm.languages = data.languages
    //       vm.skills = data.skills
    //     })
    // },
    getExperiences: async function () {
      const vm = this
      await this.$axios
        .get('member/profile/experiences')
        .then(function (response) {
          vm.experiences = response.data.experiences
        })
    },
    getLicenses: async function () {
      const vm = this
      await this.$axios.get('member/profile/licenses').then(function(response) {
        vm.licenses = response.data.licenses
      })
    },
    getEducations: async function () {
      const vm = this
      await this.$axios
        .get('member/profile/educations')
        .then(function (response) {
          vm.educations = response.data.educations
        })
    },
    getContact: async function () {
      const vm = this
      await this.$axios.get('member/profile/contact').then(function (response) {
        vm.contact = response.data
      })
    },
    getMember: async function () {
      const vm = this
      await this.$axios.get('/member/').then(function (res) {
        vm.summaryObj.summary = res.data.summary
        vm.summaryObj.overview = res.data.careerobjective
        vm.summaryObj.birthdate = res.data.birthdate
      })
    },
    getExpectation: async function () {
      const vm = this
      await this.$axios
        .get('member/profile/expectation')
        .then(function (response) {
          vm.expectation = response.data
        })
    },
    reloadSummary: async function () {
      await this.getMember()
      await this.getExpectation()
      const event = new Event('reloadProfileSummary')
      window.dispatchEvent(event)
    }
  }
}
</script>
<style lang="scss">
.editing-heading{
  font-weight: bold;
  color: #0EA5BF;
}
.part{
  &.part-3{
    padding: 30px 30px 10px !important;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
  }
  &.part-2{
    padding: 30px 30px 10px !important;
  }
  @media screen and (max-width: 575px) {
    &.part-1, &.part-2, &.part-3{
      padding: 30px 15px 10px !important;
    }
  }
}
.edu-err{
  color: red;
}
</style>
